import {Box} from 'components/Grid';
import {Typography} from 'components/Typography';
import {FaqSlider} from 'modules/events/components/Faq/FaqSlider';
import {FC} from 'react';
import 'swiper/css';
import style from './style.module.scss';

export const Faq: FC = () => {
    return (
        <Box>
            <Typography variant={'price-20-b'}>FAQ</Typography>
            <div className={style.slider}>
                <FaqSlider />
            </div>
        </Box>
    );
};
